<template>
  <a-responsive
    :aspect-ratio="$options.consts.ASPECT_RATIO.SQUARE"
    class="spotlight-section__background-wrapper"
  >
    <div class="spotlight-section__background" />

    <a-icon
      :icon="$options.consts.ICON.SPOTLIGHT_ICON_1"
      width="auto"
      height="auto"
      :no-hover="true"
      :original="true"
      :is-button="false"
      class="spotlight-section__icon"
    />
  </a-responsive>
</template>

<script>
import AIcon, { ICON } from 'shared/AIcon/index.vue'
import AResponsive from 'shared/AResponsive/index.vue'
import { ASPECT_RATIO } from 'enums/aspectRatios'

export default {
  name: 'HomepageSpotlightBackgroundIcon',
  components: { AIcon, AResponsive },
  consts: {
    ICON,
    ASPECT_RATIO
  }
}
</script>

<style lang="scss" scoped>
@keyframes rotate {
  from {
    transform: rotate(0deg);
  }
  to {
    transform: rotate(360deg);
  }
}

.spotlight-section__background-wrapper {
  .spotlight-section__background {
    position: absolute;
    width: 100%;
    height: 100%;
    background: $c--beige;
    border-radius: 50%;
  }

  .spotlight-section__icon {
    position: absolute;
    z-index: 1;

    $top: (
      $above-desktop-xl: 91px,
      $desktop-sm: 45px,
      $mobile: 45px
    );

    $width: (
      $above-desktop-xl: 78%
    );

    @include setStyleByBreakpoint('top', $top);
    @include setStyleByBreakpoint('width', $width);
  }

  /deep/ [data-id='arrow-1'],
  /deep/ [data-id='arrow-2'] {
    animation: rotate 5s linear infinite;
    transform-box: fill-box;
    transform-origin: center;
  }
}
</style>
